export default {
  install(Vue, config) {
    Vue.prototype.$breakpoint = Vue.observable(getBreakpoint(config));

    const showAtComponent = createShowAtComponent(config);
    const hideAtComponent = createHideAtComponent(showAtComponent);
    Vue.component(showAtComponent.name, showAtComponent);
    Vue.component(hideAtComponent.name, hideAtComponent);

    window.addEventListener("resize", () => {
      const newBreakpoint = getBreakpoint(config);
      const oldBreakpoint = Vue.prototype.$breakpoint;

      oldBreakpoint.xs = newBreakpoint.xs;
      oldBreakpoint.xsOnly = newBreakpoint.xsOnly;

      oldBreakpoint.sm = newBreakpoint.sm;
      oldBreakpoint.smOnly = newBreakpoint.smOnly;
      oldBreakpoint.smAndDown = newBreakpoint.smAndDown;
      oldBreakpoint.smAndUp = newBreakpoint.smAndUp;

      oldBreakpoint.md = newBreakpoint.md;
      oldBreakpoint.mdOnly = newBreakpoint.mdOnly;
      oldBreakpoint.mdAndDown = newBreakpoint.mdAndDown;
      oldBreakpoint.mdAndUp = newBreakpoint.mdAndUp;

      oldBreakpoint.lg = newBreakpoint.lg;
      oldBreakpoint.lgOnly = newBreakpoint.lgOnly;
      oldBreakpoint.lgAndDown = newBreakpoint.lgAndDown;
      oldBreakpoint.lgAndUp = newBreakpoint.lgAndUp;

      oldBreakpoint.xl = newBreakpoint.xl;
      oldBreakpoint.xlOnly = newBreakpoint.xlOnly;
      oldBreakpoint.xlAndDown = newBreakpoint.xlAndDown;
      oldBreakpoint.xlAndUp = newBreakpoint.xlAndUp;
    });
  },
};

function getBreakpoint(config) {
  const width = document.body.clientWidth;

  return {
    xs: width >= config.xs && width < config.sm,
    xsOnly: width === config.xs,
    sm: width >= config.sm && width < config.md,
    smOnly: width === config.sm,
    smAndDown: width <= config.sm,
    smAndUp: width >= config.sm,
    md: width >= config.md && width < config.lg,
    mdOnly: width === config.md,
    mdAndDown: width <= config.md,
    mdAndUp: width >= config.md,
    lg: width >= config.lg && width < config.xl,
    lgOnly: width === config.lg,
    lgAndDown: width <= config.lg,
    lgAndUp: width >= config.lg,
    xl: width >= config.xl,
    xlOnly: width === config.xl,
    xlAndDown: width <= config.xl,
    xlAndUp: width >= config.xl,
  };
}

function createShowAtComponent(config) {
  return {
    name: "VueShowAt",
    props: {
      breakpoint: {
        type: String,
        required: true,
        default: null,
        validator(value) {
          return Object.keys(getBreakpoint(config)).indexOf(value) >= 0;
        },
      },
      slim: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    render(h) {
      if (!this.$breakpoint[this.breakpoint]) {
        return;
      }

      const slim = this.slim && this.$slots.default.length <= 1;
      if (slim) {
        return this.$slots.default;
      }

      return h("div", { class: "vue-show-at" }, this.$slots.default);
    },
  };
}

function createHideAtComponent(parent) {
  return {
    name: "VueHideAt",
    extends: parent,
    render(h) {
      if (this.$breakpoint[this.breakpoint]) {
        return;
      }

      const slim = this.slim && this.$slots.default.length <= 1;
      if (slim) {
        return this.$slots.default;
      }

      return h("div", { class: "vue-hide-at" }, this.$slots.default);
    },
  };
}
